import { useParams as useRRDParams } from 'react-router-dom';

const useParams = (options) => {
  const params = useRRDParams(options);
  return params;
};

export default useParams;
